
Greenmile.TrackEquipment = Greenmile.TrackEquipment || {};

Greenmile.TrackEquipment.Utils = {

    dataMapper: {
        key: {
            type: "TEXT",
            lookupEntity: undefined
        },
        description: {
            type: "TEXT",
            lookupEntity: undefined
        }
    },

    getColumns: function () {
        return [{
            id: "equipmentKey",
            name: Monet.I18n.getResourcesByKey("equipment.key"),
            field: "key",
            width: 100,
            cssClass: "cell-row",
            sortable: true,
            resizable: false,
            formatter: function (row, cell, value) {
                return value;
            }
        },
            {
                id: "equipmentDescription",
                name: Monet.I18n.getResourcesByKey("default.description"),
                field: "description",
                width: 165,
                cssClass: "cell-row",
                sortable: true,
                resizable: false,
                formatter: function (row, cell, value) {
                    return value;
                }
            }];
    },


    createLayout: function (contentHtml) {

        var layout = {
            items: [
                {
                    tag: "div",
                    attributes: {
                        id: "TrackEquipmentWrapper"
                    },
                    items: [
                        {
                            tag: "div",
                            attributes: {
                                id: "form_TrackEquipment",
                                "class": "darkForms"
                            },
                            items: [
                                {
                                    tag: "div",
                                    attributes: {
                                        "class": "i18nResource",
                                        "id": "title"
                                    },
                                    "html": "equipment.userinterface.description"
                                },
                                {
                                    tag: "div",
                                    attributes: {
                                        "class": "monetInlineAlerContainer"
                                    }
                                }
                            ]
                        },
                        {
                            tag: "div",
                            attributes: {
                                "class": "grid_list_template"
                            },
                            items: [
                                {
                                    tag: "div",
                                    attributes: {
                                        "class": "display",
                                        "id": "grid"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    attributes: {
                        "id": "TrackEquipmentLayoutMap"
                    },
                    items: [
                        {
                            attributes: {
                                "id": "adjustsLayoutContainer"
                            },
                            items: [
                                {
                                    attributes: {
                                        "id": "mapToolbar"
                                    }
                                },
                                {
                                    attributes: {
                                        "id": "mapCon"
                                    }
                                },
                                {
                                    attributes: {
                                        "id": "trackEquipmentMapContainer"
                                    }
                                },
                                {
                                    attributes: {
                                        "id": "tabsRouteDetail"
                                    },
                                    items: [
                                        {
                                            attributes: {
                                                "id": "btnHideGridStop",
                                                "class": "gridStopsHide"
                                            }
                                        },
                                        {
                                            tag: "ul",
                                            items: [
                                                {
                                                    tag: "li",
                                                    items: [{
                                                        tag: "a",
                                                        html: "RouteDetail.tab.telematic",
                                                        attributes: {
                                                            "href": "#TrackEquipmentTelematic"
                                                        }
                                                    }]
                                                }
                                            ]
                                        },
                                        {
                                            attributes: {
                                                "id": "TrackEquipmentTelematic"
                                            }
                                        }
                                    ]
                                },
                                {
                                    attributes: {
                                        "id": "miniPlayer",
                                        "class": "miniPlayer"
                                    },
                                    items: [
                                        {
                                            attributes: {
                                                "class": "showFullGrid"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        var generator = new Monet.UI.LayoutGenerator(layout);
        contentHtml.appendChild(generator.render());

        return contentHtml;

    }

};